import { Component } from 'react';
export default class QuantcastTag extends Component {
    shouldComponentUpdate() {
        return false;
    }
    render() {
        window._qevents = window._qevents || [];
        (function () {
            var elem = document.createElement('script');
            elem.src =
                (document.location.protocol === 'https:'
                    ? 'https://secure'
                    : 'http://edge') + '.quantserve.com/quant.js';
            elem.async = true;
            elem.type = 'text/javascript';
            var scpt = document.getElementsByTagName('script')[0];
            scpt.parentNode.insertBefore(elem, scpt);
        })();
        window._qevents.push({
            qacct: 'p-BSdKknGmKHXfu',
        });
        return null;
    }
}
